<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticComputeCloudResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticComputeCloudResourceAzureVue = {};
export default {
  name: "TableElasticComputeCloudResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      instanceNameSearchIDVal: "",
      publicIpSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.Azure.VirtualMachine.accountName"),
          key: "accountName",
          fixed: "left",
          minWidth: 150
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.subscriptionName"),
          key: "subscriptionName",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.subscriptionID"),
          key: "subscriptionId",
          minWidth: 200
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.resourceGroup"),
          key: "resourceGroup",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.instanceName"),
          key: "instanceName",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.instanceType"),
          key: "instanceType",
          minWidth: 140
        },
        {
          title: "CPU",
          key: "cpu",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.cache"),
          key: "ram",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.diskStorage"),
          key: "storage",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.operatingSystem"),
          key: "os",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.instanceStatus"),
          key: "stateName",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.project"),
          key: "project",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.owner"),
          key: "owner",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.publicIP"),
          key: "publicIp",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.privateIP"),
          key: "privateIp",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.virtualNetworkAndSubnet"),
          key: "virtualNetworkSubnet",
          minWidth: 140
        },
        {
          title: this.$t("RAM.Azure.VirtualMachine.NetworkSecurityGroup"),
          key: "securityGroup",
          minWidth: 120
        }
      ],
      tableElasticComputeCloudResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableElasticComputeCloudResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableElasticComputeCloudResourceAzureVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("instanceNameSearchID", function(instanceNameSearchIDVal) {
      tableElasticComputeCloudResourceAzureVue.instanceNameSearchIDVal = instanceNameSearchIDVal;
    });
    eventBus.$on("publicIpSearchID", function(publicIpSearchIDVal) {
      tableElasticComputeCloudResourceAzureVue.publicIpSearchIDVal = publicIpSearchIDVal;
    });
    eventBus.$on("companyId", function(val) {
      tableElasticComputeCloudResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticComputeCloudResourceAzureVue.getElasticComputeCloudResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticComputeCloudResourceAzureListData: function() {
      this.$api.resourceManagement
        .queryPagingAzureInstanceConfig({
          companyId: tableElasticComputeCloudResourceAzureVue.companyId,
          accountName:
            tableElasticComputeCloudResourceAzureVue.accountNameSearchIDVal,
          instanceName:
            tableElasticComputeCloudResourceAzureVue.instanceNameSearchIDVal,
          publicIp:
            tableElasticComputeCloudResourceAzureVue.publicIpSearchIDVal,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticComputeCloudResourceAzureListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticComputeCloudResourceAzureVue.getElasticComputeCloudResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticComputeCloudResourceAzureVue.getElasticComputeCloudResourceAzureListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("accountNameSearchID");
      eventBus.$off("instanceNameSearchID");
      eventBus.$off("publicIpSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/ec2/TableElasticComputeCloudResourceAzure.vue